import React from 'react';
import { SHOTS_PER_SHOOTER_MAX } from '../../lib/shooting';

const QUICK_SHOTS = [5, 10, 15, 20];

const chip = (active: boolean) =>
  `min-h-11 min-w-12 rounded-[var(--radius-md)] border px-3 text-sm font-medium tabular-nums ${
    active
      ? 'border-[var(--color-accent)] bg-[var(--color-accent)] text-white'
      : 'border-[var(--color-border-strong)] bg-[var(--color-surface-1)] text-[var(--color-text-primary)]'
  }`;

const box =
  'h-11 w-20 rounded-[var(--radius-md)] border border-[var(--color-border-strong)] bg-[var(--color-surface-1)] px-2 text-center tabular-nums text-[var(--color-text-primary)]';

export interface FormatDraft {
  shots: string;
  /** Empty = all shots count. */
  counted: string;
}

/** Shots per shooter (quick picks 5/10/15/20 or any number) and best shots that count. */
export function FormatFields({ value, onChange }: { value: FormatDraft; onChange: (next: FormatDraft) => void }) {
  const shots = Number(value.shots);
  return (
    <div className="space-y-3">
      <fieldset>
        <legend className="mb-1 text-sm font-medium text-[var(--color-text-secondary)]">Shots per shooter</legend>
        <div className="flex flex-wrap items-center gap-2">
          {QUICK_SHOTS.map((n) => (
            <button
              key={n}
              type="button"
              className={chip(shots === n)}
              aria-pressed={shots === n}
              onClick={() => onChange({ ...value, shots: String(n) })}
            >
              {n}
            </button>
          ))}
          <input
            className={box}
            inputMode="numeric"
            aria-label="Shots per shooter"
            value={value.shots}
            maxLength={2}
            onChange={(event) => onChange({ ...value, shots: event.target.value.replace(/\D/g, '') })}
          />
        </div>
      </fieldset>
      <fieldset>
        <legend className="mb-1 text-sm font-medium text-[var(--color-text-secondary)]">Best shots that count</legend>
        <div className="flex flex-wrap items-center gap-2">
          <button
            type="button"
            className={chip(value.counted === '' || value.counted === value.shots)}
            aria-pressed={value.counted === '' || value.counted === value.shots}
            onClick={() => onChange({ ...value, counted: '' })}
          >
            All
          </button>
          <input
            className={box}
            inputMode="numeric"
            aria-label="Best shots that count"
            placeholder={value.shots || 'all'}
            value={value.counted}
            maxLength={2}
            onChange={(event) => onChange({ ...value, counted: event.target.value.replace(/\D/g, '') })}
          />
          <span className="text-xs text-[var(--color-text-tertiary)]">1 to {Number.isFinite(shots) && shots > 0 ? shots : SHOTS_PER_SHOOTER_MAX}</span>
        </div>
      </fieldset>
    </div>
  );
}
